<script setup lang="ts">
import { Head, Link } from '@inertiajs/vue3'
import PageHeading from "@/Components/Headings/PageHeading.vue"
import { PageHeading as PageHeadingTS } from '@/types/PageHeading'
import { Column, DataTable } from 'primevue';
import { useFormatCurrency } from '@/Composables/useFormatCurrency';
import { inject } from 'vue';
import { aikuLocaleStructure } from '@/Composables/useLocaleStructure';
import Icon from '@/Components/Utils/Icon.vue';
import { useFormatNumber } from '@/Composables/useFormatNumber'
import ModalConfirmationDelete from '@/Components/Utils/ModalConfirmationDelete.vue'
import Button from '@/Components/Utils/Button.vue'
import { useFormatTime } from '@/Composables/useFormatTime';


const props = defineProps<{
    pageHead?: PageHeadingTS
    title?: string
    product_category_data: {
        slug: string
        name: string
        products_count: number
        products: {}
    }
}>()

const locale = inject('locale', aikuLocaleStructure)
</script>

<template>

    <Head :title="title" />
    <PageHeading :data="pageHead">
        <!-- Button: delete -->
        <template #button-delete-product-category="{ action }">
            <div>
                <ModalConfirmationDelete
                    :routeDelete="action.route"
                    isFullLoading
                >
                    <template #default="{ isOpenModal, changeModel }">
                        <Button
                            @click="() => changeModel()"
                            :style="action.style"
                            :label="action.label"
                            :icon="action.icon"
                            :iconRight="action.iconRight"
                            :key="`ActionButton${action.label}${action.style}`"
                            :tooltip="action.tooltip"
                        />
                    </template>
                </ModalConfirmationDelete>
            </div>
        </template>
    </PageHeading>

    <div class="mt-6 grid md:grid-cols-2 px-4 sm:px-6 lg:px-8 w-full gap-x-8 gap-y-8">
        <div class="w-full">
            <div class="max-w-4xl flex justify-between items-center gap-x-4 rounded border border-gray-300 bg-gray-50 p-6">
                <div>
                    <div class="font-bold text-lg">{{ product_category_data.name }}</div>
                    <div v-tooltip="'Tgl. dibuat'" class="text-gray-400 italic">
                        {{ useFormatTime(product_category_data.created_at) }}
                    </div>
                </div>
                <div>{{ useFormatNumber(product_category_data.products_count || 0) }} produk</div>
                <!-- <div class="text-sm/6 text-gray-500">{{ product_category_data.description }}</div> -->
            </div>

            <DataTable :value="product_category_data.products" stripedRows removableSort paginator :rows="10" :rowsPerPageOptions="[5, 10, 15]" tableStyle="width: 100%" class="mt-3 max-w-4xl border border-gray-300 rounded-md">
                <Column field="code" header="Kode" sortable>
                    <template #body="{ data }">
                        <div class="flex flex-col">
                            <Link :href="route('master.products.show', data.slug)" class="primaryLink w-fit">
                                <Icon :data="data.type_icon" /> {{ data.code }}
                            </Link>
                            <div>
                                {{ data.name }}
                            </div>
                            <div class="text-gray-400">
                                {{ useFormatCurrency(data.price) }}
                            </div>
                        </div>
                    </template>
                </Column>

                <Column field="name" header="Produk" sortable headerClass="hidden md:table-cell" bodyClass="hidden md:table-cell">
                    <template #body="{ data }">
                        <div class="hidden md:block">
                            <Icon :data="data.type_icon" /> {{ data.name }}
                        </div>
                    </template>
                </Column>

                <Column field="price" sortable headerClass="hidden md:table-cell" bodyClass="hidden md:table-cell">
                    <template #header>
                        <div class="justify-end items-end flex">
                            <span class="font-bold text-right">Price</span>
                        </div>
                    </template>

                    <template #body="{ data }">
                        <div class="hidden md:block">{{ useFormatCurrency(data.price) }}</div>
                    </template>
                </Column>

                <Column field="quantity" header="Kuantitas" sortable headerClass="col-span-2">
                    <template #body="{ data }">
                        <div class="">{{ useFormatNumber(data.quantity) }} pcs</div>
            
                    </template>
                </Column>
                
                <template #empty>Belum ada produk</template>
            </DataTable>
        </div>
    </div>
</template>